import { TaxSeasonBannerContainer } from "@src/appV2/Accounts/TaxInformation/components/TaxSeasonBannerContainer";
import { ShiftDiscoveryGuidesBanner } from "@src/appV2/Knock/components/ShiftDiscoveryGuidesBanner";
import { ChartingCard } from "@src/appV2/redesign/Charting/Cards/ChartingCard";
import { HorizontalScrollView } from "@src/appV2/redesign/system/ui-components";
import { ActiveReferralBanner } from "@src/appV2/Referral/Banners/ActiveReferralBanner";

import { ClipboardScoreBanner } from "../../ClipboardScore/components/Banners/ClipboardScoreBanner";
import { ScholarshipEntrypoint } from "../../ConcordeScholarship/ScholarshipEntrypoint";
import { EarlyAccessBannerContainer } from "../../EarlyAccessFacilities/components/EarlyAccessBanner/EarlyAccessBannerContainer";
import { HolidayGiftEntrypoint } from "../../HolidayGift/Entrypoint";
import { NursesWeekNominationEntrypoint } from "../../NursesWeekNomination/Entrypoint";
import { FailedPayoutBannerContainer } from "../../Payments/FailedPayouts/components/FailedPayoutBannerContainer";
import { SetUpStripeAccountBannerContainer } from "../../Payments/Onboarding/components/SetUpStripeAccountBannerContainer";
import { StripeRestrictionBannerContainer } from "../../Payments/StripeRestriction/components/StripeRestrictionBannerContainer";
import { ReactivationBonusEntrypoint } from "../../ReactivationBonus/ReactivationBonusEntrypoint";
import { TravelShiftsEntrypoint } from "../../TravelShifts/TravelShiftsEntrypoint";
import { CancellationProtectionBannerEntrypoint } from "../../WorkerShifts/ShiftDetails/components/CancellationProtection/CancellationProtectionBannerEntrypoint";
import { BonusEligibleShiftShoppingBannerEntrypoint } from "../BonusEligibleShiftShopping/BonusEligibleShiftShoppingBannerEntrypoint";
import { NCOrientationBanner } from "../NorthCarolinaOrientation/Banner";
import { SHIFT_DISCOVERY_EARLY_ACCESS_PATH, SHIFT_DISCOVERY_NC_ORIENTATION_PATH } from "../paths";
import { ForYouButton } from "../ShiftRecommendationsView/ForYouButton";
import { useShiftModalsDataContext } from "../useShiftModalsDataContext";

interface ListViewBannersProps {
  showClipboardScoreBanner?: boolean;
}

export function ListViewBanners(props: ListViewBannersProps) {
  const { showClipboardScoreBanner = true } = props;
  const { baseNavigationPath } = useShiftModalsDataContext();

  const earlyAccessPath = `${baseNavigationPath}/${SHIFT_DISCOVERY_EARLY_ACCESS_PATH}`;
  const ncOrientationPath = `${baseNavigationPath}/${SHIFT_DISCOVERY_NC_ORIENTATION_PATH}`;

  return (
    <>
      <ForYouButton />
      <HorizontalScrollView stretch sx={{ px: 5 }}>
        <FailedPayoutBannerContainer sourceUI="shifts-tab" />
        <ReactivationBonusEntrypoint />
        <BonusEligibleShiftShoppingBannerEntrypoint />
        <ChartingCard />
        <NCOrientationBanner navigationPath={ncOrientationPath} />
        <StripeRestrictionBannerContainer sourceUI="shifts-tab" />
        <SetUpStripeAccountBannerContainer sourceUI="shifts-tab" />
        <CancellationProtectionBannerEntrypoint />
        {showClipboardScoreBanner && <ClipboardScoreBanner showEmphasizedScore />}
        <ScholarshipEntrypoint />
        <TravelShiftsEntrypoint />
        <EarlyAccessBannerContainer sourceUI="shifts-tab" navigationPath={earlyAccessPath} />
        <HolidayGiftEntrypoint />
        <NursesWeekNominationEntrypoint />
        <TaxSeasonBannerContainer sourceUI="shifts-tab" />
        <ShiftDiscoveryGuidesBanner filter={{ type: "shift-discovery-banner" }} />
        <ActiveReferralBanner />
      </HorizontalScrollView>
    </>
  );
}
